/* istanbul ignore file */
import React from 'react';
import { CandidateDuplicate } from 'domain/shared/candidate';
import { DefaultDropdownProps, Dropdown } from 'framework/form';

interface CandidateDuplicateDropdownProps extends DefaultDropdownProps {
  duplicates: CandidateDuplicate[];
}

const CandidateDuplicateDropdown = ({ duplicates, ...props }: CandidateDuplicateDropdownProps) => {
  return (
    <Dropdown
      placeholder="Choose Candidate from found duplicates"
      options={duplicates.map(duplicate => ({
        value: duplicate.candidate.id,
        label: `${duplicate.candidate.name.fullName} (id: ${duplicate.candidate.id})`,
      }))}
      {...props}
    />
  );
};

export default CandidateDuplicateDropdown;
